import React from "react"
import Layout from "../components/layout"

const ServicesPage = () => {
  return(
  <Layout>
  <div>
    <h2>Welcome to the Gatsby Plugin Library</h2>
    <p>Please use the search bar to find plugins that will make
    your blazing fast site even more awesome. If you'd like to
    create your own plugin, see the Plugin Authoring page in the
    docs! To learn more about Gatsby plugins, visit the plugins doc page.
    <a href="https://www.gatsbyjs.org/plugins/">Read More</a>
    </p>
  </div>
  </Layout>
  )
}

export default ServicesPage;
